import { render, staticRenderFns } from "./AdPreview.vue?vue&type=template&id=c5f8a50a&scoped=true&"
import script from "./AdPreview.vue?vue&type=script&lang=js&"
export * from "./AdPreview.vue?vue&type=script&lang=js&"
import style0 from "./AdPreview.vue?vue&type=style&index=0&id=c5f8a50a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f8a50a",
  null
  
)

export default component.exports